import { s as styleInject } from './style-inject.es-746bb8ed.js';

var css_248z = ".aERFs{display:block;width:100%}";
var styles = {"giphy_player":"aERFs"};
styleInject(css_248z);

export { styles as s };
//# sourceMappingURL=giphy-viewer-05f5e991.js.map
